import Container from "react-bootstrap/Container";
import { useParams } from "react-router-dom";
import Loading from "../../../components/Elements/Loading/Loading.tsx";
import PageTitle from "../../../components/Elements/PageTitle/PageTitle.tsx";
import { useGet } from "../../../components/Fetch/useFetch.tsx";
import MyFormik from "../../../components/Form/MyFormik.tsx";
import { IconEdit } from "../../../components/Icon/Icon.tsx";
import url from "../../../module/fetch.tsx";
import { URLS } from "../../../routes.tsx";
import AnomalieForm, {
  getInitialValues,
  prepareValues,
  validationSchema,
} from "./AnomalieForm.tsx";

const AnomalieUpdate = () => {
  const { anomalieId } = useParams();

  const anomalieState = useGet(url`/api/anomalie/${anomalieId}`);

  if (!anomalieState.isResolved) {
    return <Loading />;
  }

  return (
    <Container>
      <PageTitle title="Modification d'une anomalie" icon={<IconEdit />} />
      <MyFormik
        initialValues={getInitialValues(anomalieState.data)}
        prepareVariables={(values) => prepareValues(values)}
        validationSchema={validationSchema}
        submitUrl={`/api/anomalie/update/${anomalieId}`}
        isPost={false}
        redirectUrl={URLS.LIST_ANOMALIE}
        onSubmit={() => true}
      >
        <AnomalieForm />
      </MyFormik>
    </Container>
  );
};

export default AnomalieUpdate;
